<template>
    <div class="relative">
        <h5 class="text-xs mb-3">{{ title }}</h5>

        <ul v-if="data.length" class="scrolling-auto overflow-y-auto" style="max-height: calc(100vh - 510px)">
            <li v-for="item in data" :key="item.id">
                <Favored
                    :favored="item"
                    @click.native="$emit('handle-click-item', item)"
                    @remove-item="$emit('remove-item', item)">
                    <template slot="action">
                        <i class="text-gray-400 fas fa-times p-2 cursor-pointer hover:text-gray-600" @click.stop="$emit('remove-item', item)" />
                    </template>
                </Favored>
            </li>
        </ul>

        <div v-else-if="!loading" class="w-full text-center">
            <span class="text-sm">{{ messageEmpty }}</span>
        </div>

        <div v-if="loading" class="w-full h-full text-center absolute bg-gray-100 top-0 bg-opacity-20 flex items-center justify-center">
            <i class="fas fa-spinner animate-spin" />
        </div>

    </div>
</template>

<script>
import Favored from './Favored.vue';
export default {
    name: "RegisteredList",
    props: {
        data: { type: Array, default: () => [] },
        title: { type: String, required: true },
        messageEmpty: { type: String, default: "Nenhum contato registrado" },
        loading: { type: Boolean, default: false}
    },
    components: { Favored }
}
</script>
